let loadingInterval;

export function showLoadingText() {
    const modal = document.querySelector('.agent-loading-modal');
    const loadingText = document.getElementById('agent-loading-text');
    if (!modal || !loadingText) return;

    const staticMessage = "Using ML to search the internet for boat stats...";
    const cyclingMessages = [
        "Consulting ancient maritime charts...",
        "Navigating the digital high seas...",
        "Checking with the harbormaster...",
        "Calculating nautical miles...",
        "Adjusting the sails of progress...",
        "Polishing the brass of innovation..."
    ];

    loadingText.textContent = staticMessage;
    modal.classList.add('show');

    let messageIndex = 0;
    setTimeout(() => {
        loadingInterval = setInterval(() => {
            messageIndex = (messageIndex + 1) % cyclingMessages.length;
            loadingText.textContent = cyclingMessages[messageIndex];
        }, 2000);
    }, 2000);
}

export function hideLoadingText() {
    clearInterval(loadingInterval);
    const modal = document.querySelector('.agent-loading-modal');
    const loadingText = document.getElementById('agent-loading-text');
    if (modal) modal.classList.remove('show');
    if (loadingText) loadingText.textContent = '';
}
